import { useTranslation } from 'react-i18next';
import { ShieldAlert, RotateCcw } from 'lucide-react';
import { Button } from '@/components/ui/Button';

/**
 * Human, never-technical error screen (Constitución §15).
 * Explains: what happened, why, what you can do, what the system will do,
 * and when to contact support — never a raw stack trace.
 */
export function ErrorScreen() {
  const { t } = useTranslation();
  return (
    <div className="grid min-h-dvh place-items-center p-6">
      <div className="glass-strong w-full max-w-md rounded-3xl p-8 text-center">
        <div className="mx-auto mb-5 grid h-16 w-16 place-items-center rounded-2xl bg-danger/15 text-danger">
          <ShieldAlert className="h-8 w-8" />
        </div>
        <h1 className="font-display text-xl font-bold">{t('errors.generic.what')}</h1>
        <p className="mt-2 text-sm text-muted-foreground">{t('errors.generic.why')}</p>
        <ul className="mt-4 space-y-1.5 text-left text-sm text-muted-foreground">
          <li>• {t('errors.generic.action')}</li>
          <li>• {t('errors.generic.system')}</li>
          <li>• {t('errors.generic.support')}</li>
        </ul>
        <Button className="mt-6 w-full" onClick={() => window.location.assign('/')}>
          <RotateCcw className="h-4 w-4" />
          {t('empty.cta')}
        </Button>
      </div>
    </div>
  );
}
